import ClientSmsCard from '@/components/client/client-sms-card';
import {
	$appendClientDetailMessages,
	$clientDetailMessages,
	$setClientDetailMessages,
} from '@/entities/client.entity';
import { SOCKET_EVENTS } from '@/api/socket-events';
import { useClientVirtualFeed } from '@/hooks/use-client-virtual-feed';
import { getMockMessagesForClient, paginateMockItems } from '@/mocks/fixtures';
import { useUnit } from 'effector-react';

interface ClientSmsListProps {
	clientId: string;
	searchText: string;
	enabled: boolean;
	onCopy: (text: string) => void;
}

export default function ClientSmsList({ clientId, searchText, enabled, onCopy }: ClientSmsListProps) {
	const [messages, setMessages, appendMessages] = useUnit([
		$clientDetailMessages,
		$setClientDetailMessages,
		$appendClientDetailMessages,
	]);

	const { listRef, content } = useClientVirtualFeed({
		clientId,
		searchText,
		enabled,
		fetchEvent: SOCKET_EVENTS.getClientMessages,
		responseEvent: SOCKET_EVENTS.addClientMessages,
		items: messages,
		setItems: setMessages,
		appendItems: appendMessages,
		getItemId: item => item.id,
		emptyLabel: 'Сообщений нет',
		renderItem: message => <ClientSmsCard message={message} onCopy={onCopy} />,
		devMockFetch: ({ cursor, searchText: q }) => {
			const page = paginateMockItems(
				getMockMessagesForClient(clientId),
				{ cursor, searchText: q },
				(item, query) => item.text.toLowerCase().includes(query) || item.sender.toLowerCase().includes(query),
			);
			return { clientId, ...page };
		},
	});

	return (
		<div ref={listRef} data-scroll-container className='h-full overflow-auto pr-1 px-1'>
			{content}
		</div>
	);
}
